<template>
  <Dialog v-model:open="isOpen">
    <DialogTrigger as-child>
      <slot />
    </DialogTrigger>

    <DialogContent class="sm:max-w-md">
      <DialogHeader>
        <DialogTitle>{{ t('settings.mcpServers.createDialog.title') }}</DialogTitle>
        <DialogDescription>
          {{ t('settings.mcpServers.createDialog.description') }}
        </DialogDescription>
      </DialogHeader>

      <McpServersForm @submit="onSubmit">
        <DialogFooter class="gap-2">
          <Button 
            variant="outline"
            @click="isOpen = false"
          >
            {{ t('settings.mcpServers.createDialog.cancelButton') }}
          </Button>
          <Button 
            type="submit"
            :disabled="isLoading"
          >
            <LoadingIndicator 
              v-if="isLoading" 
              class="mr-2"
            />
            {{ t('settings.mcpServers.table.actions.create') }}
          </Button>
        </DialogFooter>
      </McpServersForm>
    </DialogContent>
  </Dialog>
</template>
<script lang="ts" setup>
import { useApiMcpServers } from "~/composables/api";
import type { ApiMcpServer } from "~/server/api/organizations/[organizationId]/mcpServers/types";

const { t } = useI18n();

const isOpen = ref(false);
const isLoading = ref(false);

const { organizationId } = useOrganizationId();
const { refresh } = await useApiMcpServers();

// Reset loading state when dialog closes
watch(isOpen, (newValue) => {
  if (!newValue) {
    isLoading.value = false;
  }
});

const onSubmit = async (values: ApiMcpServer) => {
  isLoading.value = true;
  
  try {
    await $fetch(`/api/organizations/${organizationId.value}/mcpServers`, {
      method: "POST",
      body: values
    });
    await refresh();
    isOpen.value = false;
  } catch (error) {
    console.error('Failed to create MCP server:', error);
  } finally {
    isLoading.value = false;
  }
};
</script>
